import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, ShieldCheck, Star, Award, CheckCircle2, ArrowRight, Clock } from 'lucide-react';
export function QuoteForm() {
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  return <section id="quote-form" className="bg-brand-50 py-20 md:py-28 scroll-mt-24" data-id="element-521" data-mp="2e66uxxglnb17">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-522" data-mp="2t3fomxtdkqw3">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-523" data-mp="2t1mirkql6ap5">
          {/* Left: pitch + testimonial */}
          <div className="lg:col-span-5" data-id="element-524" data-mp="31w18yicnn5n1">
            <div className="text-xs font-semibold uppercase tracking-widest text-brand mb-4" data-id="element-525" data-mp="31uzm7gma0uph">
              Start Here
            </div>
            <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight leading-[1.1] text-ink mb-7" data-id="element-526" data-mp="2xx1v288y3yjg">
              Free on site quote. Perth wide.
            </h2>
            <p className="text-lg leading-relaxed text-stone-700 max-w-md mb-8" data-id="element-527" data-mp="36wxbosl9slqv">
              Tell us about your home. Our team will assess the property, measure the spaces and recommend the right system in plain English. No fee and no pressure.
            </p>

            <div className="space-y-3 mb-10" data-id="element-528" data-mp="3qlo8fkv6l1d3">
              {['Same business day callback (Mon to Thu 9 to 4, Fri 9 to 2)', 'Fixed price quote in writing within 48 hours', 'We do not share or sell your details. Ever.'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-529" data-mp="8fjfev33o8dj" data-mpi={i}>
                  <CheckCircle2 size={20} className="text-success mt-0.5 flex-shrink-0" data-id="element-530" data-mp="d71ax3mctgr4" />
                  <span className="text-base text-ink" data-id="element-531" data-mp="i4t5y6iapizj">{item}</span>
                </div>)}
            </div>

            {/* Testimonial */}
            <div className="bg-white rounded-2xl p-6 border border-stone-200 shadow-md mb-8" data-id="element-532" data-mp="r6j7i55w5yb1">
              <div className="flex gap-0.5 mb-3" aria-label="5 star review" data-id="element-533" data-mp="2n9xeeegf73ci">
                {[0, 1, 2, 3, 4].map(i => <Star key={i} size={16} className="fill-accent text-accent" data-id="element-534" data-mp="2j953zhvtasen" />)}
              </div>
              <p className="text-base text-ink leading-relaxed mb-3" data-id="element-535" data-mp="2x0il6p68ze6i">
                "Straight advice, a clear fixed quote and a spotless installation. Cleaner than when the team arrived. Highly recommended."
              </p>
              <div className="text-sm text-stone-600" data-id="element-536" data-mp="370120wqv2juc">
                <strong className="text-ink" data-id="element-537" data-mp="31zmvjj4wrhyf">Sarah K.</strong> Karrinyup, ducted
                reverse cycle
              </div>
            </div>

            {/* Trust badges */}
            <div className="grid grid-cols-2 gap-4 pt-6 border-t border-stone-200" data-id="element-538" data-mp="3azrquuwtupw8">
              <div className="flex items-center gap-3" data-id="element-539" data-mp="1lklkk3p1r5tg">
                <Award size={18} className="text-brand flex-shrink-0" data-id="element-540" data-mp="1ll3nfj67siac" />
                <div data-id="element-541" data-mp="1gmabvwahn1ct">
                  <div className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold" data-id="element-542" data-mp="1gn1tu4b5x0km">
                    Accreditation
                  </div>
                  <div className="text-sm font-bold text-ink" data-id="element-543" data-mp="132kwnjvjn1o">
                    Diamond Dealer
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-544" data-mp="3jefulh1dxj3s">
                <ShieldCheck size={18} className="text-brand flex-shrink-0" data-id="element-545" data-mp="3nh2gz2faebtl" />
                <div data-id="element-546" data-mp="39htcv14cv85z">
                  <div className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold" data-id="element-547" data-mp="39hb63ak2hbjt">
                    Insured
                  </div>
                  <div className="text-sm font-bold text-ink" data-id="element-548" data-mp="30ho4annfe3q8">
                    $20M public liability
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-549" data-mp="34jjgin6wa1is">
                <Star size={18} className="text-brand flex-shrink-0" data-id="element-550" data-mp="yprr79lm0ltc" />
                <div data-id="element-551" data-mp="12rwlmajvtmh1">
                  <div className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold" data-id="element-552" data-mp="12sep9s8vj2yz">
                    Reviews
                  </div>
                  <div className="text-sm font-bold text-ink" data-id="element-553" data-mp="e0h507z2ecdx">
                    5.0 from 75 Google
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-554" data-mp="421hsg35rn9p">
                <Clock size={18} className="text-brand flex-shrink-0" data-id="element-555" data-mp="3v9dwmogkjomg" />
                <div data-id="element-556" data-mp="3v948l6f33rje">
                  <div className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold" data-id="element-557" data-mp="3r7sd4k9j4c3a">
                    Trading since
                  </div>
                  <div className="text-sm font-bold text-ink" data-id="element-558" data-mp="3mfherlufsycu">
                    1995, ABN 87 134 927 585
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-7" data-id="element-559" data-mp="3ch1otm75bv4x">
            <div className="bg-white rounded-3xl p-6 sm:p-8 lg:p-10 shadow-2xl border border-stone-200" data-id="element-560" data-mp="1s0u14t5koqfc">
              {/* Brand banner */}
              <div className="-mx-6 sm:-mx-8 lg:-mx-10 -mt-6 sm:-mt-8 lg:-mt-10 px-6 sm:px-8 lg:px-10 py-5 bg-brand text-white rounded-t-3xl mb-7" data-id="element-561" data-mp="1wyvin9ncohop">
                <div className="text-xs font-semibold uppercase tracking-widest text-white/80 mb-1" data-id="element-562" data-mp="zabtdetwm0vl">
                  Free Fixed Price Quote
                </div>
                <div className="text-xl font-bold tracking-tight" data-id="element-563" data-mp="198rjpfl3x641">
                  Our Perth team calls back the same business day.
                </div>
              </div>

              {submitted ? <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="py-12 text-center" data-id="element-564" data-mp="gleusyrh4m7k">
                  <div className="w-16 h-16 rounded-full bg-success/15 text-success flex items-center justify-center mx-auto mb-5" data-id="element-565" data-mp="9gnsdebmm5fl">
                    <CheckCircle2 size={32} data-id="element-566" data-mp="iaad89eapoa0" />
                  </div>
                  <h3 className="text-2xl font-bold text-ink mb-2" data-id="element-567" data-mp="id4xo0xb793f">Got it!</h3>
                  <p className="text-base text-stone-600 max-w-sm mx-auto" data-id="element-568" data-mp="3qqvknlra49b0">
                    Our team will call you within 2 business hours to book your free on-site quote.
                  </p>
                </motion.div> : <form onSubmit={e => {
              e.preventDefault();
              setSubmitted(true);
            }} className="space-y-5" data-id="element-569" data-mp="3vp5ik44e1o0b">
                  {/* Progress */}
                  <div className="flex items-center gap-2 mb-1" data-id="element-570" data-mp="1az7p9urwyoub">
                    <div className={`flex-1 h-1.5 rounded-full transition-colors ${step >= 1 ? 'bg-brand' : 'bg-stone-200'}`} data-id="element-571" data-mp="2sw1d52z4mvd5"></div>
                    <div className={`flex-1 h-1.5 rounded-full transition-colors ${step >= 2 ? 'bg-brand' : 'bg-stone-200'}`} data-id="element-572" data-mp="2jwxuu17sajzp"></div>
                    <span className="text-[11px] font-semibold text-stone-500 uppercase tracking-wider ml-2 tabular-nums" data-id="element-573" data-mp="2oxc2hi5h3rx7">
                      Step {step} of 2
                    </span>
                  </div>

                  {step === 1 ? <>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-574" data-mp="32v0dzzdnhmpl">
                        <div data-id="element-575" data-mp="37t277d4sj2es">
                          <label htmlFor="qf-name" className="block text-xs font-bold text-ink mb-2 uppercase tracking-wider" data-id="element-576" data-mp="37s8vryuvzoqb">
                            Your name *
                          </label>
                          <input type="text" id="qf-name" required placeholder="e.g. Sarah" className="w-full h-12 px-4 rounded-xl bg-white border-2 border-stone-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base placeholder:text-stone-400" data-id="element-577" data-mp="209zmzjxhr6t0" />
                        </div>
                        <div data-id="element-578" data-mp="2e9hdq4ucku50">
                          <label htmlFor="qf-phone" className="block text-xs font-bold text-ink mb-2 uppercase tracking-wider" data-id="element-579" data-mp="2e63a6t9y6evz">
                            Mobile *
                          </label>
                          <input type="tel" id="qf-phone" required placeholder="04XX XXX XXX" className="w-full h-12 px-4 rounded-xl bg-white border-2 border-stone-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base placeholder:text-stone-400 tabular-nums" data-id="element-580" data-mp="xvhg50iz5gkx" />
                        </div>
                      </div>

                      <div data-id="element-581" data-mp="3j8xhs03lrwgr">
                        <label htmlFor="qf-suburb" className="block text-xs font-bold text-ink mb-2 uppercase tracking-wider" data-id="element-582" data-mp="3o6p8iqsihcjd">
                          Your suburb *
                        </label>
                        <input type="text" id="qf-suburb" required placeholder="e.g. Karrinyup" className="w-full h-12 px-4 rounded-xl bg-white border-2 border-stone-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base placeholder:text-stone-400" data-id="element-583" data-mp="zn3k660klqr" />
                      </div>

                      <button type="button" onClick={() => setStep(2)} className="w-full h-14 rounded-xl bg-accent hover:bg-accent-600 text-ink font-bold text-base transition-all hover:scale-[1.01] flex items-center justify-center gap-2 shadow-lg shadow-accent/20" data-id="element-584" data-mp="3tt4yqdvaponr">
                        Continue
                        <ArrowRight size={16} strokeWidth={2.5} data-id="element-585" data-mp="gks4n22a1i1w" />
                      </button>
                    </> : <>
                      <div data-id="element-586" data-mp="qcfrepnw2ax1">
                        <label htmlFor="qf-service" className="block text-xs font-bold text-ink mb-2 uppercase tracking-wider" data-id="element-587" data-mp="qbmsgav68ppg">
                          What do you need?
                        </label>
                        <select id="qf-service" className="w-full h-12 px-4 rounded-xl bg-white border-2 border-stone-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base appearance-none cursor-pointer" data-id="element-588" data-mp="2jvy30jp7y7kw">
                          <option data-id="element-589" data-mp="25wygpip6i4rw">I am not sure, help me decide</option>
                          <option data-id="element-590" data-mp="33huj2x7oqxf9">Ducted install (whole home)</option>
                          <option data-id="element-591" data-mp="2yk1e27i4c9gk">Split install (one room)</option>
                          <option data-id="element-592" data-mp="2ylvyzlte41kn">Multi head split (2 to 4 rooms)</option>
                          <option data-id="element-593" data-mp="2trro4rh079ea">Reverse cycle replacement</option>
                          <option data-id="element-594" data-mp="2ouhuezml0bkn">Commercial install</option>
                          <option data-id="element-595" data-mp="2orvjqr4e9fy7">Old unit removal</option>
                        </select>
                      </div>

                      <div data-id="element-596" data-mp="3hinc1dic9kg9">
                        <label htmlFor="qf-timing" className="block text-xs font-bold text-ink mb-2 uppercase tracking-wider" data-id="element-597" data-mp="3hidpy10ezxfu">
                          When are you hoping to install?
                        </label>
                        <select id="qf-timing" className="w-full h-12 px-4 rounded-xl bg-white border-2 border-stone-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base appearance-none cursor-pointer" data-id="element-598" data-mp="15w3dnp301q5n">
                          <option data-id="element-599" data-mp="10x0883j3xhx5">This week (urgent)</option>
                          <option data-id="element-600" data-mp="mwpjb61cydem">This month</option>
                          <option data-id="element-601" data-mp="myabwq443m9u">Next 2 to 3 months</option>
                          <option data-id="element-602" data-mp="rur0tmj4y4nz">Just getting quotes</option>
                        </select>
                      </div>

                      <div data-id="element-603" data-mp="2hbrzgd4ioj4v">
                        <label htmlFor="qf-message" className="block text-xs font-bold text-ink mb-2 uppercase tracking-wider" data-id="element-604" data-mp="2h8e25japn04a">
                          Anything else?{' '}
                          <span className="text-stone-400 normal-case tracking-normal font-normal" data-id="element-605" data-mp="2rfgkvz04y8jz">
                            (optional)
                          </span>
                        </label>
                        <textarea id="qf-message" rows={3} placeholder="e.g. 3 bed single storey, want to cool the bedrooms only..." className="w-full px-4 py-3 rounded-xl bg-white border-2 border-stone-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base resize-none placeholder:text-stone-400" data-id="element-606" data-mp="30e0wkg7a3hyp"></textarea>
                      </div>

                      <input type="hidden" name="gclid" data-id="element-607" data-mp="1treul8kqkk2h" />
                      <input type="hidden" name="utm_source" data-id="element-608" data-mp="1ppbgsdalh3e1" />
                      <input type="hidden" name="utm_medium" data-id="element-609" data-mp="1pquwa1offaer" />
                      <input type="hidden" name="utm_campaign" data-id="element-610" data-mp="1r70ghgrdw2ef" />
                      <input type="hidden" name="utm_term" data-id="element-611" data-mp="1w5a7rg9zmiur" />
                      <input type="hidden" name="page_uri" data-id="element-612" data-mp="1w3qt1u3zcfv3" />
                      <input type="hidden" name="referrer" data-id="element-613" data-mp="206dlnx8h64tc" />

                      <div className="flex gap-3" data-id="element-614" data-mp="2052l06abtd6g">
                        <button type="button" onClick={() => setStep(1)} className="h-14 px-6 rounded-xl border-2 border-stone-200 hover:border-brand text-ink font-semibold text-sm transition-all" data-id="element-615" data-mp="254xdufdnwcu5">
                          Back
                        </button>
                        <button type="submit" className="flex-1 h-14 rounded-xl bg-accent hover:bg-accent-600 text-ink font-bold text-base transition-all hover:scale-[1.01] flex items-center justify-center gap-2 shadow-lg shadow-accent/20" data-id="element-616" data-mp="1m6uh1eevhbls">
                          Request My Quote
                          <ArrowRight size={16} strokeWidth={2.5} data-id="element-617" data-mp="m6ixv71wlvg7" />
                        </button>
                      </div>
                    </>}

                  <p className="text-center text-xs text-stone-500 flex items-center justify-center gap-1.5 pt-2" data-id="element-618" data-mp="c836d2yysk66">
                    🔒 Free quote. No obligation. No spam. No sales tactics.
                  </p>

                  <div className="flex items-center justify-center gap-2 pt-3 border-t border-stone-100 text-xs text-stone-500" data-id="element-619" data-mp="397x1i0mityn">
                    <Phone size={12} data-id="element-620" data-mp="3ulaquhy18ryn" />
                    Or call Langler Air:
                    <a href="tel:+61864043888" className="font-bold text-brand hover:underline" data-id="element-621" data-mp="3poaks716np7j">
                      08 6404 3888
                    </a>
                  </div>
                </form>}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}